._divider_xy6vv_1 {
  margin: 12px 18px; }

._menuRow_xy6vv_4 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 166px; }
  ._menuRow_xy6vv_4:hover {
    background-color: #eaf7ff; }
  ._menuRow_xy6vv_4 ._shortcut_xy6vv_12 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 3px; }
